var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('heads'),_c('router-view',{staticClass:"bodyBox",attrs:{"id":"bodyBox"}}),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }